export default {"src":"/_next/static/media/disc-types.9c75a174.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};